<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex sx12>
          <h1 class="mt-n2">{{ ct.TitleText }}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          <v-card v-else raised>
            <v-card-text class="mt-3">
              <v-form ref="form" v-model="valid">
                <v-layout justify-end>
                  <div>
                    <v-checkbox :label="ct.Active" v-model="form.active" :color="'primary'"></v-checkbox>
                  </div>
                </v-layout>
                <v-select :items="facilitiesDisplay" v-model="form.facilityDisplay" :label="$t('Facility')"></v-select>
                <v-text-field v-model="form.no" :label="$t('No.')" :rules="[rules.required]"></v-text-field>
                <v-text-field v-model="form.licensePlateNo" :label="$t('VehicleLicensePlateNo')" :rules="[rules.username]" :maxlength="40"></v-text-field>
                <v-text-field v-model="form.name" :label="ct.Name"></v-text-field>
                <v-text-field v-model="form.email" :label="$t('Emails')" :rules="[rules.emailsOptional]" :maxlength="100"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :loading="submitting"
                :disabled="!valid"
                @click="submit"
                color="success" min-width="97px"
              >{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as DateUtil from '@/core/date'
import { loadFacilities } from '@/core/archive'
import { loadVehicle, loadVehicles, saveVehiclesAndUsers } from '@/modules/asphalt-delivery/asphalt-delivery'
import * as Security from '@/core/security'
import _ from 'lodash' // clone

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'Vehicle',
    loading: true,
    submitting: false,
    valid: true,
    redirectTo: 'asphalt-delivery-vehicles',
    id: '00000000-0000-0000-0000-000000000000',
    form: {
      no: '',
      name: '',
      licensePlateNo: '',
      email: '',
      facilityNo: '',
      corporation: 1,
      active: true,
      facilityDisplay: ''
    },
    details: [],
    vehicles: [],
    facilityNo: null,
    no: null,
    facilities: null,
    facilitiesDescription: [],
    facilityDescription: '',
    useFacilityDescription: false,
    facilitiesDisplay: []
  }),

  methods: {

    async submit () {
      // If we are editing the same number just save it,
      // or else if New or changed No is entered, test if it exists in Vehicles for Facility or globally
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.form.facilityDisplay)
        if (facilityDisplay != null) {
          this.form.facilityNo = facilityDisplay.item.No
        }
      }
      if (
        this.$route.params.no === this.form.no || // Same No - just update vehicle
        (this.$route.params.id === undefined && !this.vehicles.find(v => v.No === this.form.no && v.Facility === this.form.facilityNo)) || // New vehicle
        (this.$route.params.no !== this.form.no && !this.vehicles.find(v => v.No === this.form.no && v.Facility === this.form.facilityNo))) { // Changed No on existing vehicle
        this.preventLeave = false
        if (this.$refs.form.validate()) {
          this.submitting = true
          this.details = this.details.filter(o => o.Name !== 'Comment2')
          this.details.push({ Name: 'Comment2', Value: this.form.email })
          const res = await saveVehiclesAndUsers({
            Id: this.id,
            No: this.form.no,
            LicensePlateNo: this.form.licensePlateNo,
            Facility: this.form.facilityNo,
            Name: this.form.name,
            DeletedDate: this.form.active ? null : DateUtil.getRealDate(Date.now()),
            UpdatedDate: DateUtil.getRealDate(Date.now()),
            Details: this.details
          })

          if (!res.failed) {
            this.submitting = false
            this.$root.$message.showSuccess(this.$t('Vehicle') + ' ' + this.$t('Saved'))
            this.$router.push({ name: this.redirectTo })
          }
          this.submitting = false
        }
      } else {
        // Warn user "Vehicle No. XXX already exists" and clear the No field
        this.$root.$message.showError(this.$t('Vehicle') + ' ' + this.$t('No.') + ' ' + this.form.no + ' ' + this.$t('already exists'))
        this.form.no = ''
      }
    },

    async loadFacilities () {
      const facilitiesRes = await loadFacilities()
      const facilitiesResDescription = _.cloneDeep(facilitiesRes)
      if (!facilitiesRes.failed) {
        // Let user select no facilities '' (= allow create vehicles for global facility)
        if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
        this.facilities = facilitiesRes.data.map(item => {
          return { text: item.No, value: item.No, item: item }
        })
        this.facilitiesDisplay = this.facilities
        if (this.useFacilityDescription) {
        // const facilitiesRes2 = await Archive.loadFacilities()
          var d = facilitiesResDescription.data
          if (!d.includes('')) d.unshift({ No: '', Description: '' })
          this.facilitiesDescription = d.map(item => {
            return {
              text: item.Description,
              value: item.Description,
              item: item
            }
          })

          this.facilitiesDisplay = this.facilitiesDescription
        }
      }
      if (this.useFacilityDescription) {
        this.form.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.form.facilityNo).value
      } else {
        this.form.facilityDisplay = this.facilities.find(f => f.item.No === this.form.facilityNo).value
      }
    },

    async loadVehicles () {
      // Loads ALL vehicles and add Email from Details.Comment2
      const res = await loadVehicles({ facility: '' })
      if (!res.failed) {
        this.vehicles = res.data.map(obj => ({ ...obj, Email: this.getValueFromArray(this.getItemFromArray(res.data, obj.Id, 'Details'), 'Comment2') }))
      }
    },

    getItemFromArray (array, findId, findPropertyName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        var found = array.find(o => o.Id === findId)
        if (found) {
          result = found[findPropertyName]
          if (result === undefined) result = null
        }
      }
      return result
    },

    getValueFromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        var found = array.find(o => o.Name === findName)
        if (found) {
          result = found.Value
          if (result === undefined) result = null
        }
      }
      return result
    }

  },

  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }

    if (this.$route.params.id && this.$route.params.no) {
      this.id = this.$route.params.id
      this.no = this.$route.params.no
      this.facilityNo = this.$route.params.facilityNo
      this.form.facilityDisplay = this.facilityNo
      const vehicleRes = await loadVehicle({ facilityNo: this.facilityNo, vehicleNo: this.no })
      if (!vehicleRes.failed) {
        this.form.active = vehicleRes.data.DeletedDate == null
        this.form.facilityNo = vehicleRes.data.Facility
        this.form.no = vehicleRes.data.No
        this.form.licensePlateNo = vehicleRes.data.LicensePlateNo
        this.form.name = vehicleRes.data.Name
        this.details = vehicleRes.data.Details
        this.form.email = this.details.find(o => o.Name === 'Comment2')?.Value // ScanX saves emails in Comment2 (comma separated)
      }
    }

    this.loadFacilities() // for dropdown selection
    this.loadVehicles() // load ALL, for vehicles exist check in submit()
    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>
